export default {
  common: {
    days: '天',
    today: '今天',
    remaining: '還有',
    elapsed: '已經',
    passed: '已過',
    justToday: '就在今天 🎉',
    cancel: '取消',
    save: '儲存',
    delete: '刪除',
    share: '分享',
    loading: '魔法載入中...',
    processing: '處理中...',
    demoBadge: '示範',
    saveFailed: '儲存失敗 🥺',
    deleteFailed: '刪除失敗 🥺',
    gotIt: '知道了',
  },
  date: {
    weekdays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  },
  theme: {
    sakura: '櫻花粉',
    mint: '薄荷綠',
    lavender: '薰衣草紫',
    butter: '奶油黃',
    sky: '星空藍',
    elapsed: '回憶灰'
  },
  category: {
    all: '全部分類',
    life: '日常',
    work: '工作',
    birthday: '生日',
    travel: '旅行',
    love: '戀愛',
    other: '其他'
  },
  sort: {
    default: '預設排序 (目標日最近)',
    targetDesc: '目標日最遠',
    createdDesc: '最新建立',
    titleAsc: '名稱 A-Z'
  },
  nav: {
    brandSubtitle: '倒數日',
    sponsor: '支持我們',
    toggleTheme: '切換深淺色',
    toggleLang: '切換語言',
    addEvent: '新增事件',
    login: '登入',
    logout: '登出',
    profile: '目前登入帳號',
    guestHint: '👋 訪客模式中，',
    guestLink: '點此登入',
    guestSave: '保存你的可愛回憶！',
    features: '功能介紹',
    help: '使用幫助',
    home: '返回首頁'
  },
  home: {
    tabs: {
      all: '全部時光',
      future: '期待中',
      past: '已珍藏'
    },
    empty: {
      title: '還沒有任何紀錄喔',
      desc: '趕快新增第一個期待的事件吧！',
      button: '+ 建立新事件',
      noData: '這裡目前空空的喔 🍃'
    },
    sections: {
      future: '期待中的日子',
      past: '珍藏的回憶'
    },
    hero: {
      pinned: '✨ 置頂焦點',
      coming: '🎈 即將到來',
      recent: '🕰️ 最近回憶',
      target: '目標日：'
    }
  },
  modal: {
    addTitle: '新增期待事件 🎈',
    editTitle: '編輯可愛回憶 ✏️',
    titleLabel: '標題',
    titlePlaceholder: '期待的事件 (最多 30 字)...',
    pinned: '已置頂',
    setPinned: '設置頂',
    themeLabel: '卡片主題色',
    iconLabel: '選擇可愛圖示',
    categoryLabel: '選擇分類',
    dateLabel: '目標日期',
    noteLabel: '想說的話 (選填)',
    notePlaceholder: '寫點備註吧 (最多 100 字)...',
    deleteBtn: '刪除',
    saveBtn: '儲存魔法 ✨',
    editBtn: '編輯紀錄'
  },
  confirm: {
    title: '要刪除這個回憶嗎？',
    message: '刪除之後就找不回來囉！確定要繼續嗎？ 🥺',
    cancel: '先不要',
    confirm: '殘忍刪除',
    logoutTitle: '準備要離開了嗎？',
    logoutMessage: '確定要登出目前的帳號嗎？',
    logoutConfirm: '確認登出',
    logoutCancel: '留在這裡'
  },
  share: {
    title: '分享精美小卡',
    igPost: 'Instagram 貼文 (1:1)',
    igStory: '限時動態 (9:16)',
    downloading: '魔法施展中...',
    download: '儲存精美圖片',
    error: '生成圖片失敗，請稍後再試🥺'
  },
  seduction: {
    title: '✨ 太棒了！回憶建立成功！',
    message1: '你精心設計的倒數卡片已經誕生囉！',
    message2: '不過目前是用「訪客模式」，資料只暫存在這台裝置裡 🥺',
    message3: '為了避免清理瀏覽器快取或換手機時遺失，建議你可以花 10 秒鐘免費註冊，把它安全地珍藏到雲端喔！☁️',
    registerBtn: '立刻登入 / 註冊 🚀',
    cancelBtn: '下次再說'
  },
  sponsor: {
    title: '支持 DaysMatter 💖',
    desc1: '如果 ',
    desc2: ' 讓你的生活多了一點期待，',
    desc3: '歡迎請我們喝杯咖啡，讓我們有滿滿的動力持續開發更多可愛功能！✨',
    monthly: '每月定額',
    onetime: '單次支持',
    btn: '前往支持',
    secure: '安全支付由 Stripe 提供支援，貨幣單位為 USD。',
    coffee: '喜歡 DaysMatter 嗎？請我們喝杯咖啡吧！',
    tiers: {
      m5: { name: '請喝杯咖啡 ☕', desc: '每月一杯咖啡，給我們滿滿精神！' },
      m8: { name: '請吃塊蛋糕 🍰', desc: '每月一塊蛋糕，讓開發充滿甜蜜！' },
      m10: { name: '豪華下午茶 🫖', desc: '每月豪華午茶，解鎖最大開發動力！' },
      o5: { name: '單次打氣 🎈', desc: '給我們一個小小的鼓勵！' },
      o8: { name: '暖心支持 💖', desc: '你的支持是我們前進的動力！' },
      o10: { name: '超級鼓勵 🌟', desc: '大大的擁抱！感謝你的強力支援！' }
    }
  },
  footer: {
    follow: '關注我們',
    madeWith: 'Made with',
    by: 'by'
  },
  login: {
    welcome: '歡迎來到 DaysMatter',
    subtitle: '紀錄每一個閃閃發亮的日子 ✨',
    email: '你的信箱 ✉️',
    password: '密碼 🔒',
    passwordHint: '💡 密碼長度至少需要 8 個字元',
    loginBtn: '立刻登入 🚀',
    registerBtn: '註冊新帳號 🎉',
    toggleToRegister: '還沒有帳號？來註冊一個吧！',
    toggleToLogin: '已經有帳號了？點我登入',
    or: '或者',
    guestBtn: '先用訪客身分逛逛 🚶',
    error: '請輸入信箱與密碼',
    forgotPassword: '忘記密碼？',
    resetTitle: '重設密碼',
    resetDesc: '請輸入您的信箱，我們將寄送重設密碼的連結給您。',
    sendResetBtn: '發送重設連結',
    backToLogin: '返回登入',
    resetSuccess: '重設連結已發送！請至您的信箱收取郵件 (含垃圾信件匣)。',
    newPassword: '新密碼 🔒',
    updatePasswordBtn: '更新密碼',
    updateSuccess: '密碼更新成功！請重新登入。',
    invalidToken: '無效的重設連結',
    invalidTokenDesc: '網址中找不到重設金鑰，請重新發送密碼重設要求。',
    backBtn: '返回'
  },
  errors: {
    missingCredentials: '請輸入信箱與密碼',
    notFound: '找不到該項目',
    default: '發生錯誤，請稍後再試',
    tooManyRequests: '請求次數過多，請稍後再試 🥺',
    userExists: '此信箱已經註冊過了喔！',
    passwordLength: '密碼長度至少需要 8 個字元',
    invalidCredentials: '信箱或密碼錯誤',
    authServiceUnavailable: '登入服務目前發生後台錯誤，請由網站管理員檢查 NoCodeBackend 的資料庫權限與認證設定。',
    createRecordFailed: '無法寫入伺服器，請稍後再試 🥺',
  },
  demo: {
    concert: { title: '我的超棒演唱會 🎵', note: '記得帶螢光棒！' },
    birthday: { title: '閨蜜的生日', note: '偷偷訂了草莓蛋糕 🍓' },
    trip: { title: '迪士尼之旅', note: '要玩爆所有遊樂設施！' },
    project: { title: '重要專案上線 💻', note: '連續加班的終點即將到來！' },
    anniversary: { title: '戀愛紀念日', note: '準備了驚喜禮物 🎁' },
    cat: { title: '貓主子降臨日', note: '主子駕到，天天鏟屎' },
    graduation: { title: '難忘的畢業典禮 🎓', note: '大家都要好好的！' },
    firstTrip: { title: '第一次出國冒險 ✈️', note: '開啟世界地圖的第一站' },
    braces: { title: '拆牙套倒數 🦷', note: '終於可以大口吃咖哩了！' },
    newHouse: { title: '搬進新家 🏠', note: '打造自己的溫馨小窩 🛋️' },
    firstJob: { title: '第一天上班 💼', note: '社畜人生的開始 (誤)' },
    firstDate: { title: '第一次約會 ☕', note: '那天兩個人都好緊張' },
    eighteen: { title: '18歲成年禮 👑', note: '拿到駕照的那一天！' }
  }
};